import axios from 'axios';
import config from 'config'


const endPoint = {
    auth: {
        token: "/o/token/",

    },
    event: {
        base: '/events/event/',
        getEvent: '/events/event/get_event/',
        register: '',
    },
    member: {
        getCertList: '/member/info/get_all_cert',
        getCert: '/member/info/get_online_cert/?code=',
    }
};

const api = axios.create({
    baseURL: `http://${config.services.api.uri}:${config.services.api.port}`,
    headers: {
        'Content-Type': 'application/json',
    }
})

export default {
    auth: {
        login: function (data) {
            return api.post(endPoint.auth.token, data, {headers: {'Content-Type': 'multipart/form-data'}})
        },
        refresh: function (data) {
            return new Promise((resolve, reject) => {
                api.post(endPoint.auth.token, data, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then((response) => {
                        localStorage.accessToken = response.data.access_token
                        localStorage.refreshToken = response.data.refresh_token
                        resolve(response)
                    }).catch((error) => {
                    // token = undefined
                    reject(error)
                })
            })

        },
        setToken: function (tok) {
            window.api = api
            api.defaults.headers.common['Authorization'] = "Bearer " + tok
            console.log(api.defaults)
        }
    },
    member: {
        getCert: function (mcode) {
            const url = `${endPoint.member.getCert}${mcode}`;
            return api.get(url);
        }
    },
    event: {
        getEvent: function (id) {
            const url = `${endPoint.event.base}${id}`;
            return api.get(url);
        },
        register: function (id, body) {
            const url = `${endPoint.event.base}${id}/register`;
            return api.post(url, body);
        }
    }

}



// WEBPACK FOOTER //
// ./src/service.js